import {jsclj, resolveGoogExport} from 'dgetz/tsclj'
import {typingPhoneFmt} from 'ladder/common2'
import React from 'react'

interface TextInputProps {
  value: string;
  onChange: Function;
  fullWidth?: boolean;
  textSize?: string;
  textWeight?: string;
  placeholder?: string;
  floatingPlaceholder?: boolean;
  removeBorder?: boolean;
  disabled?: boolean;
  type?: string;
  inputMode?: string;
  pattern?: string;
  maxLength?: number;
  fmtFn?: Function;
}

export function TextInput(props : TextInputProps) {
  let {text_input} = resolveGoogExport('ladder.ux.form')
  return text_input(jsclj({
    'value': props.value,
    'on-change': props.onChange,
    'full-width?': props.fullWidth,
    'text-size': props.textSize,
    'text-weight': props.textWeight,
    'placeholder': props.placeholder,
    'floating-placeholder?': props.floatingPlaceholder,
    'remove-border': props.removeBorder ? 'remove-border' : null,
    'type': props.type,
    'input-mode': props.inputMode,
    'pattern': props.pattern,
    'max-length': props.maxLength,
    'fmt-fn': props.fmtFn ?? (() => null),
    'disabled': props.disabled,
  }))
}

export function EmailInput(props: TextInputProps) {
  return <TextInput type='email' {...props}/>
}

export function PhoneInput(props: TextInputProps) {
  return <TextInput type='tel'
                    inputMode='tel'
                    pattern='[0-9\\(\\) -]*'
                    maxLength={14}
                    fmtFn={typingPhoneFmt}
                    {...props}/>

}
